// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2UDW0","detailsBorder":"styles_detailsBorder__3kjLB"};